$(document).on("turbolinks:load", function () {
  $(".js-product-variantPrice").on("change", function () {
    $(".js-variant-container.active").removeClass("active")
    $(this).closest(".js-variant-container").addClass("active")
  })
})
